import Pagination from '../Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'
import './SolutionsDigitalTransformation.css'

const SolutionsDigitalTransformation = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesDigital = [
    {
      id: 1,
      title: 'solutionsDigitalTransformation_page.cases.items.ecommerce.title',
      description:
        'solutionsDigitalTransformation_page.cases.items.ecommerce.description',
      icon: '',
      url: 'plataforma-de-e-commerce',
    },
    {
      id: 2,
      title: 'solutionsDigitalTransformation_page.cases.items.pricing.title',
      description: 'solutionsDigitalTransformation_page.cases.items.pricing.description',
      icon: '',
      url: 'plataforma-de-gestao-de-precos',
    },
    {
      id: 3,
      title: 'solutionsDigitalTransformation_page.cases.items.export.title',
      description: 'solutionsDigitalTransformation_page.cases.items.export.description',
      icon: '',
      url: 'plataforma-de-exportacao',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsDigitalTransformation_page.cases.cta')
    const caseTitle = t(caseItem.title)

    trackCtaClick({
      cta_name: 'solutions_related_case_click',
      cta_location: 'solutions_digital_transformation',
      page_name: 'solutions_digital_transformation',
      case_title: caseTitle,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container solutions-digital">
      <header className="main-container-top">
        <div className="text">
          <h1>{t('solutionsDigitalTransformation_page.title')}</h1>
          <p>
            {t('solutionsDigitalTransformation_page.description1')}
            <br />
            {t('solutionsDigitalTransformation_page.description2')}
          </p>
        </div>

        <div className="image-container">
          <img
            src="/assets/SolutionsPage/digital transformations.png"
            alt={t('solutionsDigitalTransformation_page.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('solutionsDigitalTransformation_page.main.title')}</h2>
          <p>
            {t('solutionsDigitalTransformation_page.main.description1')}
            <br />
            {t('solutionsDigitalTransformation_page.main.description2')}
          </p>

          <img
            className="full-width-image"
            src={t('solutionsDigitalTransformation_page.main.digitalTransformationImage')}
            alt={t('solutionsDigitalTransformation_page.main.imageAlt')}
          />

          <p>
            {t('solutionsDigitalTransformation_page.main.details.p1')}
            <br />
            {t('solutionsDigitalTransformation_page.main.details.p2')}
            <br />
            {t('solutionsDigitalTransformation_page.main.details.p3')}
            <br />
            {t('solutionsDigitalTransformation_page.main.details.p4')}
            <br />
            {t('solutionsDigitalTransformation_page.main.details.p5')}
          </p>

          <div className="ProductDevelopment">
            <h3>{t('solutionsDigitalTransformation_page.productDevelopment.title')}</h3>
            <img
              src={t(
                'solutionsDigitalTransformation_page.productDevelopment.productDevelopmentImage',
              )}
              alt={t('solutionsDigitalTransformation_page.productDevelopment.imageAlt')}
            />
          </div>
        </div>
      </div>

      <div className="main-content our-performance-container">
        <header>
          <h2>{t('solutionsDigitalTransformation_page.performance.title')}</h2>
          <p>{t('solutionsDigitalTransformation_page.performance.subtitle')}</p>
        </header>
        <div className="our-performance-content">
          <div className="performance-row">
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.roadmap.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.roadmap.description',
                )}
              </p>
            </div>

            <div className="performance-card">
              <h3>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.processes.title',
                )}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.processes.description',
                )}
              </p>
            </div>

            <div className="performance-card">
              <h3>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.architecture.title',
                )}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.architecture.description',
                )}
              </p>
            </div>

            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.change.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.change.description',
                )}
              </p>
            </div>
          </div>

          <div className="performance-row">
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.web.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.web.description',
                )}
              </p>
            </div>

            <div className="performance-card">
              <h3>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.responsive.title',
                )}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.responsive.description',
                )}
              </p>
            </div>
          </div>

          <div className="performance-row">
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.ios.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.ios.description',
                )}
              </p>
            </div>
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.android.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.android.description',
                )}
              </p>
            </div>
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.apis.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.apis.description',
                )}
              </p>
            </div>
            <div className="performance-card">
              <h3>
                {t('solutionsDigitalTransformation_page.performance.cards.support.title')}
              </h3>
              <p>
                {t(
                  'solutionsDigitalTransformation_page.performance.cards.support.description',
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="main-cases-container solutions-digital">
        <h2 className="title">{t('solutionsDigitalTransformation_page.cases.title')}</h2>
        <p className="subtitle">
          {t('solutionsDigitalTransformation_page.cases.subtitle')}
        </p>

        <Pagination data={casesDigital} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="case-icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault()
                      handleRelatedCaseCtaClick(caseItem)
                    }}
                  >
                    {t('solutionsDigitalTransformation_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default SolutionsDigitalTransformation
